import * as logger from 'loglevel';
import { useState, useCallback, useEffect } from 'react';

const useFetchCredits = ({ v1CounterAPI: url }) => {
  /*

  This is the object of credits return by the counterAPI from EveryMundo
  {
    "value": 10,
    "total": 9986,
    "done": false,
    "session": "cfec9fd6815dd7d85cbd86100868d13fbb51932617e1747692c6df7680b24758"
  }
  */
  const [credits, setCredits] = useState({
    done: true,
    value: 0 //Initial value has setter to 10 and this value is override when request is done
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [creditConsumed, setConsumed] = useState(false);

  const fetchCredits = useCallback(async () => {
    try {
      const response = await fetch(url?.endPoint);
      //The quota for this session has been consumed
      if ((credits?.value === 1 || creditConsumed) && response.status === 401 && !response.ok) {
        logger.info('The quota for this session has been consumed');
        setConsumed(true);
        setCredits({ value: 0 });
      } else {
        const result = await response.json();
        setCredits(result);
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [url, credits?.value, creditConsumed]);

  useEffect(() => {
    fetchCredits();
  }, [url, fetchCredits]);

  return { credits, error, loading, setCredits, canMakeRequest: credits?.value > 0, fetchCredits };
};

export { useFetchCredits };
